<template>
  <div class="body">
    <div class="main" v-for="(item, index) in itemcount" :key="index">
      <a-input :placeholder="placeholder" v-model="item.name" style="margin-left:8px" @change="changeValue"/><a-icon
        type="double-right"
      />
      <a-input :placeholder="placeholder" v-model="item.value" @change="changeValue"/><a-icon type="double-right" />
      <a-input :placeholder="placeholder" v-model="item.description" @change="changeValue"/><a-icon
        v-if="index > 0 ? false : true"
        type="plus"
        style="margin-left:8px"
        @click="add"
      /><a-icon
        type="minus"
        style="margin-left:8px"
        v-if="index > 0 ? true : false"
        @click="del(index)"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ["modelList","placeholder"],
  data() {
    return {
      itemcount: [],
    };
  },
  watch: {
    modelList: {
      handler(val) {
        if (val.length > 0) {
          val.map((item) => {
            if (item.property === "properties") {
              if (item.value === ""||item.value.length===0) {
                item.value = [];
                item.value.push({ description: "", id: "", name: "", value: "" });
              }
            }
            this.itemcount = item.value;
          });
        }
        console.log(8888, val);
      },
      immediate: true,
    },
  },
  methods: {
    add() {
      this.itemcount.push({ description: "", id: "", name: "", value: "" });
      console.log(888, this.itemcount);
    },
    del(index) {
      this.itemcount.splice(index, 1);
    },
    changeValue() {
      this.$emit('change',this.itemcount)
    }
  },
};
</script>

<style lang="less" scoped>
.body {
  border: 1px solid #d9d9d9;
  height: 150px;
  overflow: auto;
}
.main {
  display: flex;
  align-items: center;
  margin-top: 8px;
}
</style>
